import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'address-card': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVcard" */
        '@fortawesome/free-solid-svg-icons/faVcard'
    ),
    'angle-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAngleRight" */
        '@fortawesome/free-solid-svg-icons/faAngleRight'
    ),
    'arrow-down-up-across-line': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowDownUpAcrossLine" */
        '@fortawesome/free-solid-svg-icons/faArrowDownUpAcrossLine'
    ),
    'arrows-rotate': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSync" */
        '@fortawesome/free-solid-svg-icons/faSync'
    ),
    'arrows-up-down-left-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faArrowsUpDownLeftRight" */
        '@fortawesome/free-solid-svg-icons/faArrowsUpDownLeftRight'
    ),
    'award': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faAward" */
        '@fortawesome/free-solid-svg-icons/faAward'
    ),
    'b': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faB" */
        '@fortawesome/free-solid-svg-icons/faB'
    ),
    'bahai': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHaykal" */
        '@fortawesome/free-solid-svg-icons/faHaykal'
    ),
    'baseball-bat-ball': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBaseballBatBall" */
        '@fortawesome/free-solid-svg-icons/faBaseballBatBall'
    ),
    'bathtub': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBathtub" */
        '@fortawesome/free-solid-svg-icons/faBathtub'
    ),
    'battery-quarter': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryQuarter" */
        '@fortawesome/free-solid-svg-icons/faBatteryQuarter'
    ),
    'battery-three-quarters': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBatteryThreeQuarters" */
        '@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters'
    ),
    'bicycle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBicycle" */
        '@fortawesome/free-solid-svg-icons/faBicycle'
    ),
    'book-open': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBookOpen" */
        '@fortawesome/free-solid-svg-icons/faBookOpen'
    ),
    'border-top-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBorderTopLeft" */
        '@fortawesome/free-solid-svg-icons/faBorderTopLeft'
    ),
    'boxes-packing': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBoxesPacking" */
        '@fortawesome/free-solid-svg-icons/faBoxesPacking'
    ),
    'bridge': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBridge" */
        '@fortawesome/free-solid-svg-icons/faBridge'
    ),
    'bridge-circle-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBridgeCircleCheck" */
        '@fortawesome/free-solid-svg-icons/faBridgeCircleCheck'
    ),
    'business-time': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faBusinessTime" */
        '@fortawesome/free-solid-svg-icons/faBusinessTime'
    ),
    'calendar-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCalendarXmark" */
        '@fortawesome/free-solid-svg-icons/faCalendarXmark'
    ),
    'chain': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLink" */
        '@fortawesome/free-solid-svg-icons/faLink'
    ),
    'chess-bishop': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChessBishop" */
        '@fortawesome/free-solid-svg-icons/faChessBishop'
    ),
    'chevron-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChevronDown" */
        '@fortawesome/free-solid-svg-icons/faChevronDown'
    ),
    'chevron-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChevronRight" */
        '@fortawesome/free-solid-svg-icons/faChevronRight'
    ),
    'church': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faChurch" */
        '@fortawesome/free-solid-svg-icons/faChurch'
    ),
    'circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCircle" */
        '@fortawesome/free-solid-svg-icons/faCircle'
    ),
    'circle-pause': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPauseCircle" */
        '@fortawesome/free-solid-svg-icons/faPauseCircle'
    ),
    'clock-rotate-left': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHistory" */
        '@fortawesome/free-solid-svg-icons/faHistory'
    ),
    'cloud-meatball': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCloudMeatball" */
        '@fortawesome/free-solid-svg-icons/faCloudMeatball'
    ),
    'cloud-sun-rain': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCloudSunRain" */
        '@fortawesome/free-solid-svg-icons/faCloudSunRain'
    ),
    'commenting': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCommenting" */
        '@fortawesome/free-solid-svg-icons/faCommenting'
    ),
    'crop-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCropSimple" */
        '@fortawesome/free-solid-svg-icons/faCropSimple'
    ),
    'cubes-stacked': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faCubesStacked" */
        '@fortawesome/free-solid-svg-icons/faCubesStacked'
    ),
    'diagram-successor': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDiagramSuccessor" */
        '@fortawesome/free-solid-svg-icons/faDiagramSuccessor'
    ),
    'dice-three': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDiceThree" */
        '@fortawesome/free-solid-svg-icons/faDiceThree'
    ),
    'disease': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDisease" */
        '@fortawesome/free-solid-svg-icons/faDisease'
    ),
    'divide': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faDivide" */
        '@fortawesome/free-solid-svg-icons/faDivide'
    ),
    'eraser': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faEraser" */
        '@fortawesome/free-solid-svg-icons/faEraser'
    ),
    'expand-arrows-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMaximize" */
        '@fortawesome/free-solid-svg-icons/faMaximize'
    ),
    'face-smile': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSmile" */
        '@fortawesome/free-solid-svg-icons/faSmile'
    ),
    'face-smile-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSmileWink" */
        '@fortawesome/free-solid-svg-icons/faSmileWink'
    ),
    'file-circle-question': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileCircleQuestion" */
        '@fortawesome/free-solid-svg-icons/faFileCircleQuestion'
    ),
    'file-csv': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileCsv" */
        '@fortawesome/free-solid-svg-icons/faFileCsv'
    ),
    'file-text': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFileText" */
        '@fortawesome/free-solid-svg-icons/faFileText'
    ),
    'fire-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFireFlameCurved" */
        '@fortawesome/free-solid-svg-icons/faFireFlameCurved'
    ),
    'folder-tree': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFolderTree" */
        '@fortawesome/free-solid-svg-icons/faFolderTree'
    ),
    'forward': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faForward" */
        '@fortawesome/free-solid-svg-icons/faForward'
    ),
    'frog': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFrog" */
        '@fortawesome/free-solid-svg-icons/faFrog'
    ),
    'funnel-dollar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faFunnelDollar" */
        '@fortawesome/free-solid-svg-icons/faFunnelDollar'
    ),
    'gem': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGem" */
        '@fortawesome/free-solid-svg-icons/faGem'
    ),
    'glass-cheers': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlassCheers" */
        '@fortawesome/free-solid-svg-icons/faGlassCheers'
    ),
    'glass-martini-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMartiniGlass" */
        '@fortawesome/free-solid-svg-icons/faMartiniGlass'
    ),
    'globe-oceania': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGlobeOceania" */
        '@fortawesome/free-solid-svg-icons/faGlobeOceania'
    ),
    'guarani-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faGuaraniSign" */
        '@fortawesome/free-solid-svg-icons/faGuaraniSign'
    ),
    'hand-dots': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandDots" */
        '@fortawesome/free-solid-svg-icons/faHandDots'
    ),
    'hand-fist': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandFist" */
        '@fortawesome/free-solid-svg-icons/faHandFist'
    ),
    'hands-american-sign-language-interpreting': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandsAslInterpreting" */
        '@fortawesome/free-solid-svg-icons/faHandsAslInterpreting'
    ),
    'handshake-angle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandshakeAngle" */
        '@fortawesome/free-solid-svg-icons/faHandshakeAngle'
    ),
    'handshake-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHandshakeSlash" */
        '@fortawesome/free-solid-svg-icons/faHandshakeSlash'
    ),
    'hard-hat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHelmetSafety" */
        '@fortawesome/free-solid-svg-icons/faHelmetSafety'
    ),
    'haykal': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHaykal" */
        '@fortawesome/free-solid-svg-icons/faHaykal'
    ),
    'headset': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHeadset" */
        '@fortawesome/free-solid-svg-icons/faHeadset'
    ),
    'highlighter': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHighlighter" */
        '@fortawesome/free-solid-svg-icons/faHighlighter'
    ),
    'hot-tub': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHotTubPerson" */
        '@fortawesome/free-solid-svg-icons/faHotTubPerson'
    ),
    'hotdog': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHotdog" */
        '@fortawesome/free-solid-svg-icons/faHotdog'
    ),
    'hourglass': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHourglassEmpty" */
        '@fortawesome/free-solid-svg-icons/faHourglassEmpty'
    ),
    'house-lock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHouseLock" */
        '@fortawesome/free-solid-svg-icons/faHouseLock'
    ),
    'hryvnia': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faHryvniaSign" */
        '@fortawesome/free-solid-svg-icons/faHryvniaSign'
    ),
    'industry': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faIndustry" */
        '@fortawesome/free-solid-svg-icons/faIndustry'
    ),
    'institution': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUniversity" */
        '@fortawesome/free-solid-svg-icons/faUniversity'
    ),
    'jedi': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faJedi" */
        '@fortawesome/free-solid-svg-icons/faJedi'
    ),
    'lari-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLariSign" */
        '@fortawesome/free-solid-svg-icons/faLariSign'
    ),
    'left-long': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLongArrowAltLeft" */
        '@fortawesome/free-solid-svg-icons/faLongArrowAltLeft'
    ),
    'level-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLevelUp" */
        '@fortawesome/free-solid-svg-icons/faLevelUp'
    ),
    'lungs': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faLungs" */
        '@fortawesome/free-solid-svg-icons/faLungs'
    ),
    'magnifying-glass-minus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSearchMinus" */
        '@fortawesome/free-solid-svg-icons/faSearchMinus'
    ),
    'money-bill-1-wave': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faMoneyBillWaveAlt" */
        '@fortawesome/free-solid-svg-icons/faMoneyBillWaveAlt'
    ),
    'parachute-box': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faParachuteBox" */
        '@fortawesome/free-solid-svg-icons/faParachuteBox'
    ),
    'pencil-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePen" */
        '@fortawesome/free-solid-svg-icons/faSquarePen'
    ),
    'people-arrows': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPeopleArrowsLeftRight" */
        '@fortawesome/free-solid-svg-icons/faPeopleArrowsLeftRight'
    ),
    'people-arrows-left-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPeopleArrowsLeftRight" */
        '@fortawesome/free-solid-svg-icons/faPeopleArrowsLeftRight'
    ),
    'person-harassing': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonHarassing" */
        '@fortawesome/free-solid-svg-icons/faPersonHarassing'
    ),
    'person-military-pointing': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonMilitaryPointing" */
        '@fortawesome/free-solid-svg-icons/faPersonMilitaryPointing'
    ),
    'person-praying': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPray" */
        '@fortawesome/free-solid-svg-icons/faPray'
    ),
    'person-walking-dashed-line-arrow-right': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPersonWalkingDashedLineArrowRight" */
        '@fortawesome/free-solid-svg-icons/faPersonWalkingDashedLineArrowRight'
    ),
    'phone-flip': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPhoneFlip" */
        '@fortawesome/free-solid-svg-icons/faPhoneFlip'
    ),
    'phone-square-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePhoneFlip" */
        '@fortawesome/free-solid-svg-icons/faSquarePhoneFlip'
    ),
    'pray': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faPray" */
        '@fortawesome/free-solid-svg-icons/faPray'
    ),
    'route': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faRoute" */
        '@fortawesome/free-solid-svg-icons/faRoute'
    ),
    'scroll-torah': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTorah" */
        '@fortawesome/free-solid-svg-icons/faTorah'
    ),
    'shoe-prints': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShoePrints" */
        '@fortawesome/free-solid-svg-icons/faShoePrints'
    ),
    'shop-lock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShopLock" */
        '@fortawesome/free-solid-svg-icons/faShopLock'
    ),
    'shopping-basket': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faShoppingBasket" */
        '@fortawesome/free-solid-svg-icons/faShoppingBasket'
    ),
    'slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSlash" */
        '@fortawesome/free-solid-svg-icons/faSlash'
    ),
    'snowplow': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSnowplow" */
        '@fortawesome/free-solid-svg-icons/faSnowplow'
    ),
    'spell-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSpellCheck" */
        '@fortawesome/free-solid-svg-icons/faSpellCheck'
    ),
    'square-phone': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSquarePhone" */
        '@fortawesome/free-solid-svg-icons/faSquarePhone'
    ),
    'stamp': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStamp" */
        '@fortawesome/free-solid-svg-icons/faStamp'
    ),
    'stop-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faStopCircle" */
        '@fortawesome/free-solid-svg-icons/faStopCircle'
    ),
    'subtract': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSubtract" */
        '@fortawesome/free-solid-svg-icons/faSubtract'
    ),
    'swatchbook': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faSwatchbook" */
        '@fortawesome/free-solid-svg-icons/faSwatchbook'
    ),
    'table-cells-large': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThLarge" */
        '@fortawesome/free-solid-svg-icons/faThLarge'
    ),
    'tablet-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTabletScreenButton" */
        '@fortawesome/free-solid-svg-icons/faTabletScreenButton'
    ),
    'tachometer-average': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTachometerAverage" */
        '@fortawesome/free-solid-svg-icons/faTachometerAverage'
    ),
    'tarp-droplet': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTarpDroplet" */
        '@fortawesome/free-solid-svg-icons/faTarpDroplet'
    ),
    'temperature-low': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTemperatureLow" */
        '@fortawesome/free-solid-svg-icons/faTemperatureLow'
    ),
    'temperature-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTemperatureUp" */
        '@fortawesome/free-solid-svg-icons/faTemperatureUp'
    ),
    'tent-arrows-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTentArrowsDown" */
        '@fortawesome/free-solid-svg-icons/faTentArrowsDown'
    ),
    'thermometer-three-quarters': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faThermometerThreeQuarters" */
        '@fortawesome/free-solid-svg-icons/faThermometerThreeQuarters'
    ),
    'torii-gate': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faToriiGate" */
        '@fortawesome/free-solid-svg-icons/faToriiGate'
    ),
    'tornado': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTornado" */
        '@fortawesome/free-solid-svg-icons/faTornado'
    ),
    'trademark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrademark" */
        '@fortawesome/free-solid-svg-icons/faTrademark'
    ),
    'trailer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrailer" */
        '@fortawesome/free-solid-svg-icons/faTrailer'
    ),
    'trash-can-arrow-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTrashRestoreAlt" */
        '@fortawesome/free-solid-svg-icons/faTrashRestoreAlt'
    ),
    'truck-field': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faTruckField" */
        '@fortawesome/free-solid-svg-icons/faTruckField'
    ),
    'user-doctor': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserMd" */
        '@fortawesome/free-solid-svg-icons/faUserMd'
    ),
    'user-md': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUserMd" */
        '@fortawesome/free-solid-svg-icons/faUserMd'
    ),
    'users': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faUsers" */
        '@fortawesome/free-solid-svg-icons/faUsers'
    ),
    'v': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faV" */
        '@fortawesome/free-solid-svg-icons/faV'
    ),
    'vcard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVcard" */
        '@fortawesome/free-solid-svg-icons/faVcard'
    ),
    'virus-covid-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVirusCovidSlash" */
        '@fortawesome/free-solid-svg-icons/faVirusCovidSlash'
    ),
    'voicemail': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVoicemail" */
        '@fortawesome/free-solid-svg-icons/faVoicemail'
    ),
    'volleyball': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faVolleyballBall" */
        '@fortawesome/free-solid-svg-icons/faVolleyballBall'
    ),
    'water': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWater" */
        '@fortawesome/free-solid-svg-icons/faWater'
    ),
    'wine-glass-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWineGlassEmpty" */
        '@fortawesome/free-solid-svg-icons/faWineGlassEmpty'
    ),
    'won-sign': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faWonSign" */
        '@fortawesome/free-solid-svg-icons/faWonSign'
    ),
    'x': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-solid-faX" */
        '@fortawesome/free-solid-svg-icons/faX'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>